export { default } from './use-input-mask';
